import { configureStore } from "@reduxjs/toolkit";
import loginReducer from './Login/loginSlice'; 
import itemPageReducer from "./ItemPageService/ItemPageSlice";
import HistoryReducer from "./HistoryService/HistorySlice";
import ledgerReducer from "./LedgerService/ledgerSlice";
import CustomerMasterReducer from "./CustomerMasterService/CustomerMasterSlice";

const store = configureStore({
    reducer: {
      login: loginReducer,
      itemPage : itemPageReducer, 
      history : HistoryReducer,
      LedgerReport:ledgerReducer,
      CustomerMaster:CustomerMasterReducer
    },
});

export default store;
